<template>
  <component
    :is="$vuetify.display.smAndDown ? VBottomSheet : VDialog"
    class="app-dialog"
    v-bind="$attrs"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </component>
</template>

<script setup lang="ts">
import { VBottomSheet } from 'vuetify/components/VBottomSheet'
import { VDialog } from 'vuetify/components/VDialog'
import type { ComponentSlots } from 'vue-component-type-helpers'

defineSlots<ComponentSlots<typeof VDialog> | ComponentSlots<typeof VBottomSheet>>()

defineProps<
  /* @vue-ignore */ | InstanceType<typeof VBottomSheet>['$props']
  | InstanceType<typeof VDialog>['$props']
>()

defineOptions({
  inheritAttrs: false,
})
</script>

<style lang="scss">
.v-overlay-container .v-dialog.v-bottom-sheet.app-dialog > .v-overlay__content {
  max-width: 100% !important;
}
</style>
